import { useMutation } from '@tanstack/react-query'
import { postRequest } from 'utils/api/apiRequest'

type Data = {
  code_challenge: string
  password: string
}

export const usePostPasswordVerification = (
  onSuccess: (tokens: { accessToken: string; refreshToken: string }) => void
) => {
  return useMutation({
    mutationFn: (data: Data) =>
      postRequest<{
        token_type: string
        expires_in: number
        access_token: string
        refresh_token: string
      }>(`/2fa/password-verification`, data),
    onSuccess: (data) => {
      try {
        onSuccess({
          accessToken: data.data.access_token,
          refreshToken: data.data.refresh_token,
        })
      } catch (e) {
        console.error('Error setting auth tokens', e)
      }
    },
  })
}
